module.exports = __webpack_public_path__ + "static/media/si.c2844c75.svg";